var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('h3',[_vm._v("Наш блог")]),_c('div',{staticClass:"row"},_vm._l((_vm.articlesList),function(item){return _c('BlogItem',{attrs:{"item":item}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }